import styled from 'styled-components';

export const RowContainer = styled.div`
  .col-7 {
    padding-left: 16px;
  }
`;